import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { getDatabase, ref, set, get, child } from "firebase/database";
import UElogo from "../assets/UElogo_horizontal.png";
import AppFooter from "../components/AppFooter";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAaR9ZU1w_bFxMKMbNxu-9eBpuOOGm1Eow",
  //authDomain: "reservas-eartes.uevora.pt",  
  authDomain: "bookingappv1-d1e2d.firebaseapp.com",
  databaseURL: "https://bookingappv1-d1e2d-default-rtdb.firebaseio.com/",
  projectId: "bookingappv1-d1e2d",
  storageBucket: "bookingappv1-d1e2d.appspot.com",
  messagingSenderId: "134532713601",
  appId: "1:134532713601:web:5ad89fec3f4bf09b519180",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getDatabase(app);

export default function LoginPage() {
  const [user, setUser] = useState(null);
  const [consentChecked, setConsentChecked] = useState(false);
  const [showConsent, setShowConsent] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, async (currentUser) => {
      if (
        currentUser &&
          (currentUser.email.endsWith("@uevora.pt") ||
            currentUser.email.endsWith("@alunos.uevora.pt"))
      ) {
        const dbRef = ref(db);
        const consentSnap = await get(
          child(dbRef, `users/${currentUser.uid}/consent`),
        );
        const consent = consentSnap.exists() && consentSnap.val();

        if (consent === true) {
          setUser(currentUser);
          navigate("/buildings");
        } else {
          setUser(currentUser);
          setShowConsent(true); // Show checkbox if no consent found
        }
      } else {
        setUser(null);
        signOut(auth);
      }
    });
  }, [navigate]);

  const handleConsentSubmit = async () => {
    if (consentChecked && user) {
      await set(ref(db, `users/${user.uid}`), {
        email: user.email,
        name: user.displayName,
        consent: true,
        consentAcceptedAtISO: new Date().toISOString()
      });
      navigate("/buildings");
    } else {
      alert("You must agree to the visibility condition to proceed.");
    }
  };

  const signIn = () => {
    signInWithPopup(auth, provider)
      .then(async (result) => {
        const email = result.user.email;
        if (
          email.endsWith("@uevora.pt") ||
            email.endsWith("@alunos.uevora.pt")
        ) {
          setUser(result.user);

          const dbRef = ref(db);
          const consentSnap = await get(
            child(dbRef, `users/${result.user.uid}/consent`),
          );
          const consent = consentSnap.exists() && consentSnap.val();

          if (consent === true) {
            navigate("/buildings");
          } else {
            setShowConsent(true);
          }
        } else {
          alert("Access restricted to emails of the University of Évora.");
          signOut(auth);
        }
      })
      .catch((error) => console.error("Login error: ", error));
  };

  const goToContact = () => {
    navigate("/contact");
  };
  const goToTerms = () => {
    navigate("/terms-of-use");
  };

  return (
    <div className="flex flex-col p-6 pt-28 items-center justify-start min-h-screen bg-gray-800 text-gray-100 p-8">
      {/* Top bar with logo and buttons */}
      <div className="w-full flex justify-between items-center px-6 py-4 absolute top-0 left-0">
        {/* Logo on the left */}
        <img src={UElogo} alt="UE Logo" className="h-12 w-auto" />
        {/* Buttons on the right */}
        <div className="flex gap-4"></div>
      </div>
      <h1 className="w-full mb-8 text-left px-6 text-xl font-bold">
        Space Reservation for the School of Arts
      </h1>
      <p className="text-gray-300 mb-4">
        Welcome to the School of Arts Space Reservation System. This platform
        allows students, faculty, and staff of the University of Évora to book
        classrooms and meeting spaces for academic and creative activities.
        <br />
        <br />
        To get started, sign in with your institutional email.
      </p>

      {!user || !showConsent ? (
        <button
          onClick={signIn}
          className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded"
        >
          Sign In
        </button>
      ) : (
          <div className="bg-gray-700 p-6 rounded-lg shadow-md w-full max-w-md">
            <p className="mb-4">
              By continuing, you agree with the Terms of Use and that the information about your
              reservation, your name and email, will be made available to other
              users.
            </p>
            <label className="flex items-center space-x-2 mb-4">
              <input
                type="checkbox"
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
                className="form-checkbox h-4 w-4 text-blue-600"
              />
              <span>I agree</span>
            </label>
            <div className="flex justify-center">
              <button
                onClick={handleConsentSubmit}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
              >
                Continue
              </button>
            </div>
          </div>
        )}
      <AppFooter />    
    </div>
  );
}
